if (!customElements.get('wls-newsletter-form')) {
  class WLSNewsletterForm extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        active: 'active',
        buttonSubmit: 'js-newsletter-submit',
        feedbackMessage: 'js-feedback-message',
        emailInput: 'input[name="contact[email]"]',
        sectionId: `${this.getAttribute('data-newsletter-form')}`,
      };

      this.selectors = {
        submitButton: this.querySelector(`.${this.classes.buttonSubmit}`),
      };

      this.apiUrl = 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe';
      this.listGroup = 'Sy89Ti';

      this.feedbackMessages = {
        successMessage: 'Thank you for subscribing!',
        validationEmailMessage: 'Please enter a valid email address.',
        alreadySubscribedMessage: 'You have already subscribed.',
        unexpectedErrorMessage: 'An error occurred. Please try again later.',
      };
    }

    /**
     * Lifecycle method called when the element is added to the DOM.
     * It sets up event listeners for each tag to handle tag selection.
     */
    connectedCallback() {
      this.loadSettings();
      this.bindEvents();
    }

    bindEvents() {
      this.selectors.submitButton.addEventListener('click', this.handleSubmit.bind(this));
    }

    loadSettings() {
      const settingsElement = document.getElementById(`NewsletterFeedbackMessages-${this.classes.sectionId}`);

      if (settingsElement) {
        const incomingMessages = JSON.parse(settingsElement.textContent);

        Object.keys(incomingMessages).forEach((key) => {
          if (incomingMessages[key]) {
            this.feedbackMessages[key] = incomingMessages[key];
          }
        });
      }
    }

    handleSubmit(e) {
      e.preventDefault();

      // Selectors
      const formSelector = e.target.closest('form');
      const emailInput = formSelector.querySelector(this.classes.emailInput);
      const isEmail = this.isEmail(emailInput.value);
      const messageSelector = formSelector.querySelector(`.${this.classes.feedbackMessage}`);

      // If email is valid, subscribe to the newsletter, otherwise show a message
      if (isEmail) {
        this.subscribeEmail(emailInput.value, messageSelector);
      } else {
        this.displayMessage(messageSelector, `${this.feedbackMessages.validationEmailMessage}`, 'error');
      }
    }

    async subscribeEmail(email, messageSelector) {
      try {
        const response = await fetch(this.apiUrl, {
          headers: {
            accept: 'application/json, text/plain, */*',
            'content-type': 'application/x-www-form-urlencoded;charset=UTF-8',
          },
          body: new URLSearchParams({ g: this.listGroup, email }),
          method: 'POST',
        });

        const data = await response.json();

        if (data.data.is_subscribed) {
          this.displayMessage(messageSelector, `${this.feedbackMessages.alreadySubscribedMessage}`, 'error');
        } else if (data.success) {
          this.displayMessage(messageSelector, `${this.feedbackMessages.successMessage}`, 'success');
        }
      } catch (error) {
        this.displayMessage(messageSelector, `${this.feedbackMessages.unexpectedErrorMessage}`, 'error');
      }
    }

    displayMessage(selector, message, type) {
      selector.innerHTML = message;
      selector.classList.toggle('success', type === 'success');
      selector.classList.toggle('error', type === 'error');
    }

    /**
     * Check if string is a valid email address.
     * @param {string} email
     * @returns {boolean}
     */
    isEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    }
  }

  window.customElements.define('wls-newsletter-form', WLSNewsletterForm);
}
